// tslint:disable:max-line-length

import React from 'react';

export const EditorAlignCenter = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M0 0v2h16v-2h-16zm2 4v2h12v-2h-12zm-2 4v2h16v-2h-16zm2 4v2h12v-2h-12z" transform="translate(0 1)" />
    </svg>
  );
};
